import type { Enums } from "../types";

export const teamCapabilities: Array<Enums<"teamCapability">> = [
	"crew-scheduling",
	"receive-substitution-list-copy",
	"vehicle-scheduling",
	"manage-project",
	"invoice-approval",
] as const;
